// export type PieChartProps = {
//   width: number;
//   height: number;
//   events?: boolean;
//   data: BrowserUsage[];
//   margin?: { top: number; right: number; bottom: number; left: number };
// };
import Pie from "@visx/shape/lib/shapes/Pie";
import { scaleOrdinal } from "@visx/scale";
import { Group } from "@visx/group";

const data = [
  ["Chrome", 48],
  ["Internet Explorer", 18],
  ["Firefox", 34],
  ["Edge", 21],
  ["Safari", 23],
];

const defaultMargin = { top: 10, right: 10, bottom: 10, left: 10 };
const getUsage = (d) => d[1];

export default function PieChart({ data, margin = defaultMargin }) {
  const getBrowserColor = scaleOrdinal({
    domain: data.map((d) => d[0]),
    range: [
      "var(--legendary-2)",
      "var(--epic-2)",
      "var(--rare-2)",
      "var(--uncommon-2)",
      "var(--common-2)",
    ],
  });

  const width = 180;
  const height = 180;
  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;

  const centerY = innerHeight / 2;
  const centerX = innerWidth / 2;
  const top = centerY + margin.top;
  const left = centerX + margin.left;

  const radius = Math.min(innerWidth, innerHeight) / 2;

  return (
    <svg width={width} height={height}>
      <Group top={top} left={left}>
        <Pie
          data={data}
          pieValue={getUsage}
          outerRadius={radius}
          innerRadius={25}
          padAngle={0.03}
        >
          {(pie) => {
            return pie.arcs.map((arc, index) => {
              const [browser] = arc.data;
              const [centroidX, centroidY] = pie.path.centroid(arc);
              const arcAngle = arc.endAngle - arc.startAngle;
              const hasSpaceForLabel = arc.endAngle - arc.startAngle >= 0.1;
              const arcPath = pie.path(arc);
              const arcFill = getBrowserColor(browser);
              return (
                <g key={`arc-${browser}-${index}`}>
                  <path d={arcPath} fill={arcFill} />
                  {hasSpaceForLabel && (
                    <>
                      <text
                        className="font-roboto font-medium text-shadow-w"
                        x={centroidX * 1.05}
                        y={centroidY * 1.05}
                        width={50}
                        dy="-.6em"
                        fill="rgba(0, 0, 0, 0.87)"
                        fontSize={arcAngle < 0.5 ? 10 : 12}
                        textAnchor="middle"
                        pointerEvents="none"
                      >
                        {arc.data[0]}
                      </text>
                      <text
                        className="font-roboto font-medium text-shadow-w"
                        x={centroidX * 1.05}
                        y={centroidY * 1.05}
                        width={50}
                        dy=".6em"
                        fill="rgba(0, 0, 0, 0.87)"
                        fontSize={arcAngle < 0.5 ? 10 : 12}
                        textAnchor="middle"
                        pointerEvents="none"
                      >
                        {arc.data[1].toFixed(1)}
                        {arcAngle < 0.5 ? "" : "%"}
                      </text>
                    </>
                  )}
                </g>
              );
            });
          }}
        </Pie>
      </Group>
    </svg>
  );
}
